import React, {useEffect} from 'react';

import "../../layouts/layouts.scss";
import TopAppBar from "../Shared/TopAppBar";
import DomainSidebar from "./DomainSidebar";

import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import Utility from "../../Utility";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {administrationRoleEnum} from "../../serverClientShared/sharedEnums";

const DomainWrapper = observer(props => {
    const {generalStore} = useStores();
    const hideTopBar = generalStore.hideTopBar;
    useEffect(() => {
        generalStore.checkPermission(administrationRoleEnum.WORKSPACE_ADMIN)
    }, []);
    return (
        <ConditionalComponent if={generalStore.isLoaderOpen !== true}>
            <div className="wrapper domain-users-page">
                <TopAppBar {...props}/>
                <div className='sidebar-main-container'>
                    <DomainSidebar/>
                    <div className={"main-panel theme" + (Utility.isMobile() ? '' : ' sidebar-open')} style={{height: 'unset'}}>
                        <div className={"content domain-wrapper" + (hideTopBar ? ' top-hidden' : '') + (props.wide ? ' wide' : '') + (props.ultraWide ? ' ultra-wide' : '')}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </ConditionalComponent>
    );
});

export default DomainWrapper;
